// extracted by mini-css-extract-plugin
export default {"favoriteCompact":"favoriteCompact__ZGEwM","heartImg":"heartImg__YzMxY"};